exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ustYazi[data-v-48ea653c]{margin-top:20px}", ""]);

// exports
